import axios from 'axios'
import {arrayFilter} from '../../shared/ArrayHelper.js'
import authHeader from '../../services/AuthHeader'


const MS_CORE = process.env.VUE_APP_MS_CORE

const state = () => ({
    customer :{
        id: "",
        name: ""
    },
    contrats:[],
    locos:[],
    filterLoc:[],
    teams:[],
    totalKmYear: 0,
    fleat: {
        total: 0,
        available: 0
    }

})

const getters = {
    getFleat(state){
        return state.fleat
    },

    getTotalKmYear(state){
        return state.totalKmYear
    },

    getTeams(state){
        return state.teams
    },

    getContrats(state){
        if(state.contrats.length>0){
            return state.contrats
        }
        let contrats  = localStorage.getItem("contrats")
        if(contrats != null){
           // state.contrats = JSON.parse(contrats)
        }
        return state.contrats
    },

    getCustomer(state){
        return state.customer
    },

    getFilterLoc(state){
        if(state.filterLoc.length > 0){
            return state.filterLoc
        }
        let locos = localStorage.getItem("filterLoc")
        if(locos != null){
            state.filterLoc = JSON.parse(locos)
        }
        return state.filterLoc
    },

    getLocos(state){
        if(state.locos.length > 0){
            return state.locos
        }
        let locos = localStorage.getItem("locos")
        if(locos != null){
            state.locos = JSON.parse(locos)
        }
        return state.locos
    }

}

const mutations = {
    saveFleat(state){
        
        if(state.filterLoc.length > 0){
            let available = 0
            let idx
            for(idx = 0; idx < state.filterLoc.length; idx ++){
                if(state.filterLoc[idx].status){
                    available ++
                }
            }
            state.fleat.total = state.filterLoc.length
            state.fleat.available = available
        }else{
            state.fleat= {
                total: 0,
                available: 0
            }
        }
        
    },

    saveTotalKmYear(state, data){
        state.totalKmYear = data
    },

    saveTeams(state,data){
        state.teams = data
    },

    saveContrats(state, data){
        localStorage.setItem("contrats", JSON.stringify(data))
        state.contrats = data
    },

    saveCustomer(state, data){
        if(data == null){
            state.customer = {
                id:"",
                name:""
            }
        }else{
            state.customer = data
        }
    },

    saveLocos(state, data){
        state.filterLoc = arrayFilter(data)     
        state.locos = data
        localStorage.setItem("locos", JSON.stringify(data))
        localStorage.setItem("filterLoc", JSON.stringify(state.filterLoc))
    }

}

const actions = {

    loadFleet({commit}){
        commit("saveFleat")
    },

    async loadContrats({commit}, value){
        const response = await axios.get(`${MS_CORE}/secure/agreements/` + value, {headers: authHeader()})
        .catch(err => {
            console.log("store contrat:" + err)
        })
        if(response && response.data){
            commit("saveContrats", response.data)
        }else{
            commit("saveContrats",[])
        }
    },

    async loadTeams({commit}, value){
        const response = await axios.get(`${MS_CORE}/secure/teams/` + value, {headers: authHeader()})
        .catch(err => {
            console.log("store teams:" + err)
        })
        if(response && response.data){
            commit("saveTeams", response.data)
        }else{
            commit("saveTeams",[])
        }
    },


    async loadCustomer({commit}, value){
        const response = await axios.get(`${MS_CORE}/secure/customer/` + value , {headers: authHeader()})
        .catch(err => {
            console.log("store customer:" + err)
        })
        if(response && response.data){
            let customer = {
                id: response.data.customernum,
                name: response.data.name
            }
            commit("saveCustomer", customer)
        }else{
            commit("saveCustomer",null)
        }
    },

    async loadLocos({commit}, payload){
        const response = await axios.post(`${MS_CORE}/secure/locos`,  payload, {headers: authHeader()})
        .catch(err => {
            console.log("store locos:" + err)
        })
        if(response && response.data){
            commit("saveLocos", response.data)
            commit("saveFleat")
        }else{
            commit("saveLocos",[])
            commit("saveFleat")
        }
        
    },

}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}